// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';

import './SelectedInfo.scss';

interface SelectedInfoProps {
    count: number;
    label: string;
}

export const SelectedInfo = ({ count, label }: SelectedInfoProps): ReactElement | null =>
    count ? <span className="selected-info">{`(${count}) ${label}`}</span> : null;
